import CheckboxBase from '@/global/components/Form/Base/Checkbox'
import { Divider, Grid } from '@mui/material'
import { FormField, FormFieldCheckbox } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import CabecalhoTabelaHorarioForm from './CabecalhoForm'
import PreviewEspelhoForm from './PreviewEspelhoForm'
import { HorariosForm } from './TabelaHorariosForm'
import { TipoTabelaForm } from './TipoTabelaForm'
import { ToleranciasForm } from './ToleranciasForm'

export default function FormTabelaHorario() {
    const { watch, setValue } = useFormContext()
    const isSemanal = watch('tipo') === 'SEMANAL'
    const acumulaPausas = watch('pausasAcumulam')
    const tempoPausas = watch('tempoPausas')
    const maximoPausas = watch('maximoPausas')
    const incluirPausas = watch(
        'usarPausas',
        !!tempoPausas && tempoPausas !== '00:00',
    )

    const handleChangePausas = () => {
        setValue('usarPausas', !incluirPausas)

        if (incluirPausas) {
            setValue('tempoPausas', '00:00')
            setValue('maximoPausas', 1)
            setValue('pausasAcumulam', false)
            setValue('horasExtraPausas', false)
            setValue('faltaPausas', false)
        } else {
            setValue('tempoPausas', '00:10')
            setValue('maximoPausas', 2)
            setValue('pausasAcumulam', true)
            setValue('horasExtraPausas', false)
            setValue('faltaPausas', false)
        }
    }

    const MemoizedPreviewEspelho = React.useMemo(
        () => <PreviewEspelhoForm />,
        [],
    )

    if (isSemanal) {
        return (
            <>
                <CabecalhoTabelaHorarioForm />
                <TipoTabelaForm />
            </>
        )
    }

    return (
        <>
            <CabecalhoTabelaHorarioForm />
            <TipoTabelaForm />
            <Grid item xs={12} sx={{ mb: 2 }}>
                <Divider>
                    <span className="inline-flex items-center text-base">
                        Tolerâncias{' '}
                        <IconeAjuda>
                            Tolerâncias podem ser definidas por registro, dia ou
                            turno.
                            <br />
                            <br />
                            Caso opte por tolerâncias por dia ou turno, as
                            demais opções não serão consideradas.
                            <br />
                            <br />
                            Você também pode alterar a configuração do
                            funcionário para utilizar a tolerância CLT, nesse
                            caso, o sistema vai considerar automaticamente a
                            tolerância padrão de 5 minutos para cada registro
                            com um máximo de 10 minutos por dia.
                        </IconeAjuda>
                    </span>
                </Divider>
            </Grid>
            <ToleranciasForm />
            <Grid item xs={12} sx={{ mb: 2, mt: 4 }}>
                <Divider>Horários</Divider>
            </Grid>
            <HorariosForm />
            <Grid item xs={12} sx={{ mb: 2, mt: 4 }}>
                <Divider>Espelho do ponto</Divider>
            </Grid>
            {MemoizedPreviewEspelho}
            <Grid item xs={12} sx={{ mb: 2, mt: 4 }}>
                <Divider>Pausas</Divider>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item xs={3}>
                    <CheckboxBase
                        checked={incluirPausas}
                        onChange={handleChangePausas}
                    >
                        Incluir pausa
                        <IconeAjuda>
                            Este campo define se o sistema deve considerar
                            pausas ou não. Caso esteja marcado, o sistema vai
                            considerar pausas na jornada de trabalho do
                            funcionário.
                        </IconeAjuda>
                    </CheckboxBase>
                </Grid>
                <Grid item xs={2.5}>
                    <FormField
                        name="tempoPausas"
                        label="Tempo de pausa por turno"
                        InputLabelProps={{ shrink: true }}
                        placeholder="HH:mm"
                        disabled={!incluirPausas}
                        type="time"
                        InputProps={{
                            endAdornment: (
                                <IconeAjuda className="-mb-4">
                                    Este campo define quanto tempo por turno
                                    será considerado como pausa. O sistema não
                                    contabiliza faltas para esse tempo.
                                    <br />
                                    <br />A carga horária de telemarketing, por
                                    exemplo, prevê pausas de até 10 minutos.
                                </IconeAjuda>
                            ),
                        }}
                        autoComplete="off"
                    />
                </Grid>
                <Grid item xs={3}>
                    <FormField
                        name="maximoPausas"
                        label="Máximo de pausas por jornada"
                        InputLabelProps={{ shrink: true }}
                        min={1}
                        disabled={!incluirPausas}
                        onChange={e => {
                            if (Number(e.target.value) === 1) {
                                setValue('pausasAcumulam', false)
                            }
                        }}
                        type="number"
                        InputProps={{
                            endAdornment: (
                                <IconeAjuda className="-mb-4 mr-1">
                                    Este campo define quantas pausas serão
                                    consideradas por jornada. O sistema não
                                    contabiliza faltas para esse tempo.
                                    <br />
                                    <br />A carga horária de telemarketing, por
                                    exemplo, prevê duas pausas por jornada.
                                </IconeAjuda>
                            ),
                        }}
                        autoComplete="off"
                        placeholder="0"
                    />
                </Grid>
                <Grid
                    item
                    xs={3.5}
                    sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        mt: -3,
                    }}
                >
                    <FormFieldCheckbox
                        name="pausasAcumulam"
                        label="Acumular pausa"
                        onChange={(_, checked) => {
                            if (!checked) {
                                setValue('horasExtraPausas', false)
                                setValue('faltaPausas', false)
                            }
                        }}
                        disabled={!incluirPausas || Number(maximoPausas) < 2}
                    />
                    <IconeAjuda>
                        Este campo define se as pausas acumulam ou não. Caso
                        esteja marcado, o sistema vai procurar quaisquer faltas
                        que com tempo menor que tempo de pausa muiltiplicado
                        pelo máximo de pausas por jornada.
                        <br />
                        <br />
                        Por exemplo, duas pausas de 10 minutos acumuladas não
                        consideram faltas mesmo se o funcionário faltar 15
                        minutos em um turno e 5 minutos em outro.
                    </IconeAjuda>
                </Grid>
                <Grid
                    item
                    xs={6}
                    sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                    }}
                >
                    <FormFieldCheckbox
                        name="horasExtraPausas"
                        label="Incluir horas extras por pausas"
                        disabled={!incluirPausas || acumulaPausas}
                    />
                    <IconeAjuda>
                        Este campo define se o sistema deve considerar horas
                        extras para pausas. Caso esteja marcado, o sistema vai
                        considerar horas extras para pausas.
                        <br />
                        <br />
                        Por exemplo, se um funcionário pausar 15 minutos em uma
                        pausa de 20 minutos, o sistema vai considerar 5 minutos
                        como hora extra.
                    </IconeAjuda>
                </Grid>
                <Grid
                    item
                    xs={6}
                    sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                    }}
                >
                    <FormFieldCheckbox
                        name="faltaPausas"
                        label="Incluir faltas por pausas"
                        disabled={!incluirPausas || acumulaPausas}
                    />
                    <IconeAjuda>
                        Este campo define se o sistema deve considerar faltas
                        para pausas. Caso esteja marcado, o sistema vai
                        considerar faltas para pausas.
                        <br />
                        <br />
                        Por exemplo, se um funcionário pausar 25 minutos em uma
                        pausa de 20 minutos, o sistema vai considerar 5 minutos
                        como falta.
                    </IconeAjuda>
                </Grid>
                <Grid item xs={12} sx={{ mb: 2, mt: 4 }}>
                    <Divider>Interjornada</Divider>
                </Grid>
                <Grid item xs={4}>
                    <FormField
                        name="horasIntervalares"
                        label="Horas intervalares"
                        placeholder="HH:mm"
                        type="time"
                        InputProps={{
                            endAdornment: (
                                <IconeAjuda>
                                    <p>
                                        Esse campo determina quantas horas
                                        intervalares vão ser concedidas ao
                                        funcionário sempre que ele trabalhar no
                                        dia.
                                    </p>
                                    <p>
                                        As horas intervalares serão exibidas no
                                        espelho do ponto e na integração com a
                                        folha de pagamento.
                                    </p>
                                    <p>
                                        Deixe em branco para não considerar
                                        horas intervalares.
                                    </p>
                                </IconeAjuda>
                            ),
                        }}
                        autoComplete="off"
                    />
                </Grid>
            </Grid>
        </>
    )
}
